export default __webpack_public_path__ + "static/media/option-laminate.fae00d6d.png";